import type {
  ProviderSettingsProfileTabFormValues,
} from '@/schemas/practitioner.schema';

export const EMPTY_PROVIDER_PROFILE_TAB: ProviderSettingsProfileTabFormValues = {
  preferredFirstName: '',
  preferredLastName: '',
  phone: '',
  street: '',
  city: '',
  state: '',
  zipCode: '',
  languages: [],
  bio: '',
  pronouns: '',
  genderIdentity: '',
  lgbtqiaIdentity: '',
  religion: [],
  raceEthnicity: [],
  ageGroups: [],
  specialties: [],
  modalities: [],
};
